import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/Layout";
import Seo from "../components/Seo";
import Header from "../components/Header";
import DynamicChildren from "../components/DynamicChildren";

const ArticlePage = ({ pageContext, location, data }) => {
    const { page } = data;
    const { header, dynamicComponents } = page;

    return (
        <Layout className="article" location={location}>
            <Header banner={page?.banner} header={header} location={location} />

            <DynamicChildren
                contentfulComponents={dynamicComponents}
                article={data.article}
                pageContext={pageContext}
            />
        </Layout>
    );
};

export const Head = ({ data }) => {
    const article = data.article;
    const metadata = [];

    if (article.image?.url) {
        metadata.push({
            key: "og:image",
            property: "og:image",
            content: article.image.url,
        });
    }
    return (
        <Seo
            defaultTitle={article.title}
            seoRobots={article.seoRobots}
            seoDescription={article.seoDescription}
            meta={metadata}
        />
    );
};

export default ArticlePage;

export const ArticlePageQuery = graphql`
    query ArticlePageQuery($slug: String) {
        page: contentfulPage(path: { eq: "/article/post" }) {
            header {
                ...HeaderData
            }
            ...DynamicComponents
        }
        article: contentfulArticle(slug: { eq: $slug }) {
            slug
            seoDescription {
                seoDescription
            }
            publishDate
            image {
                gatsbyImageData(layout: CONSTRAINED)
                title
                description
                file {
                    contentType
                    url
                }
                url
            }
            title
            body {
                raw
            }
            seoRobots
        }
    }
`;
